module.exports = __webpack_public_path__ + "img/icon-asset-bess.223042ac.png";